import { render, staticRenderFns } from "./DesignContent3.vue?vue&type=template&id=e33ea6c4&"
import script from "./DesignContent3.vue?vue&type=script&lang=ts&"
export * from "./DesignContent3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports